import React from 'react';
import { Card, Grid } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// Import chart components
import ReportsBarChart from 'examples/Charts/BarCharts/ReportsBarChart';
import ReportsLineChart from 'examples/Charts/LineCharts/ReportsLineChart';
import ReportsBarChartMulti from 'examples/Charts/BarCharts/ReportsBarChartMulti';

function ProductionsReports() {
    // Sample data for charts - replace with real data from your API
    const barChartData = {
        labels: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz'],
        datasets: {
            label: 'Üretim Sayısı',
            data: [50, 40, 60, 80, 65, 75, 95],
        },
    };

    const lineChartData = {
        labels: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz'],
        datasets: {
            label: 'Tamamlanan Üretimler',
            data: [30, 25, 35, 50, 40, 60, 70],
        },
    };

    const multiBarChartData = {
        labels: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma'],
        datasets: [
            {
                label: 'Başlandı',
                color: 'info',
                data: [15, 20, 12, 25, 10],
            },
            {
                label: 'Tamamlandı',
                color: 'success',
                data: [5, 10, 8, 15, 8],
            },
            {
                label: 'İptal Edildi',
                color: 'error',
                data: [2, 3, 1, 0, 2],
            },
        ],
    };

    return (
        <MDBox>
            <MDBox mb={3}>
                <Grid container spacing={3}>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        <MDBox mb={3}>
                            <Card>
                                <MDBox p={3}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                        Aylara Göre Üretim Sayısı
                                    </MDTypography>
                                    <ReportsBarChart
                                        color="info"
                                        title="Üretim Sayısı"
                                        description="Son 7 aya ait üretim sayısı grafiği"
                                        date="son güncelleme: şimdi"
                                        chart={barChartData}
                                    />
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        <MDBox mb={3}>
                            <Card>
                                <MDBox p={3}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                        Tamamlanan Üretimler
                                    </MDTypography>
                                    <ReportsLineChart
                                        color="success"
                                        title="Tamamlanan Üretimler"
                                        description="Son 7 aya ait tamamlanan üretim grafiği"
                                        date="son güncelleme: şimdi"
                                        chart={lineChartData}
                                    />
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        <MDBox mb={3}>
                            <Card>
                                <MDBox p={3}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                        Haftalık Üretim Durumu
                                    </MDTypography>
                                    <ReportsBarChartMulti
                                        color="dark"
                                        title="Haftalık Üretim Durumu"
                                        description="Bu haftaya ait üretim durumu grafiği"
                                        date="son güncelleme: şimdi"
                                        chart={multiBarChartData}
                                    />
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
            <MDBox>
                <Grid container spacing={3}>
                    <Grid size={12}>
                        <Card>
                            <MDBox p={3}>
                                <MDTypography variant="h6" fontWeight="medium" mb={2}>
                                    Üretim İstatistikleri
                                </MDTypography>
                                <Grid container spacing={3}>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 3
                                        }}>
                                        <MDBox bgColor="info" borderRadius="lg" p={2} textAlign="center" color="white">
                                            <MDTypography variant="h3" fontWeight="bold">
                                                547
                                            </MDTypography>
                                            <MDTypography variant="button" fontWeight="regular">
                                                Toplam Üretim
                                            </MDTypography>
                                        </MDBox>
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 3
                                        }}>
                                        <MDBox
                                            bgColor="success"
                                            borderRadius="lg"
                                            p={2}
                                            textAlign="center"
                                            color="white"
                                        >
                                            <MDTypography variant="h3" fontWeight="bold">
                                                385
                                            </MDTypography>
                                            <MDTypography variant="button" fontWeight="regular">
                                                Tamamlanan
                                            </MDTypography>
                                        </MDBox>
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 3
                                        }}>
                                        <MDBox
                                            bgColor="warning"
                                            borderRadius="lg"
                                            p={2}
                                            textAlign="center"
                                            color="white"
                                        >
                                            <MDTypography variant="h3" fontWeight="bold">
                                                142
                                            </MDTypography>
                                            <MDTypography variant="button" fontWeight="regular">
                                                Devam Eden
                                            </MDTypography>
                                        </MDBox>
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 3
                                        }}>
                                        <MDBox bgColor="error" borderRadius="lg" p={2} textAlign="center" color="white">
                                            <MDTypography variant="h3" fontWeight="bold">
                                                20
                                            </MDTypography>
                                            <MDTypography variant="button" fontWeight="regular">
                                                İptal Edilen
                                            </MDTypography>
                                        </MDBox>
                                    </Grid>
                                </Grid>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </MDBox>
    );
}

export default ProductionsReports;
